module.exports = __webpack_public_path__ + "img/productSatellite_20.338da165.png";